
import React, { useEffect } from 'react';

const Contact: React.FC = () => {
  useEffect(() => {
    // Limpar qualquer script anterior
    const existingScript = document.getElementById('zl-widget-s');
    if (existingScript) {
      existingScript.remove();
    }

    // Carregar o script do Doctoralia
    const script = document.createElement('script');
    script.innerHTML = `!function($_x,_s,id){var js,fjs=$_x.getElementsByTagName(_s)[0];if(!$_x.getElementById(id)){js = $_x.createElement(_s);js.id = id;js.src = "//platform.docplanner.com/js/widget.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","zl-widget-s");`;
    document.head.appendChild(script);

    return () => {
      // Cleanup ao desmontar o componente
      const scriptToRemove = document.getElementById('zl-widget-s');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const scrollToAgendamento = () => {
    const agendamentoSection = document.getElementById('agendamento');
    if (agendamentoSection) {
      agendamentoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="contato" className="py-8 md:py-24 bg-gradient-to-br from-slate-50 to-slate-100 relative overflow-hidden">
      {/* Subtle background elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-slate-200/20 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-slate-300/15 to-transparent rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-3 md:px-6 relative z-10">
        <div className="text-center mb-8 md:mb-20">
          {/* Professional badge */}
          <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 md:px-6 py-2 md:py-3 rounded-lg mb-4 md:mb-8 shadow-sm border border-slate-200">
            <div className="w-2 h-2 bg-slate-600 rounded-full"></div>
            <span className="text-slate-700 font-semibold text-xs md:text-sm tracking-wide uppercase">Agendamento Online</span>
          </div>

          <h2 className="text-2xl md:text-5xl lg:text-6xl font-bold text-slate-800 mb-4 md:mb-8 leading-tight px-2" style={{ fontFamily: 'Inter, sans-serif' }}>
            Agende Sua
            <span className="text-slate-600 block font-light">Consulta</span>
          </h2>
          <p className="text-base md:text-xl text-slate-600 max-w-4xl mx-auto leading-relaxed font-medium px-4">
            Sistema integrado de agendamento online com confirmação automática 
            e gestão profissional de horários disponíveis
          </p>
        </div>

        {/* CTA para agendamento */}
        <div className="text-center mb-8 md:mb-16">
          <button
            onClick={scrollToAgendamento}
            className="inline-flex items-center gap-2 md:gap-3 bg-slate-800 hover:bg-slate-700 text-white px-4 md:px-12 py-3 md:py-6 rounded-lg md:rounded-2xl transition-all duration-300 font-bold shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-sm md:text-xl border border-slate-600 hover:border-slate-500 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-lg md:text-2xl"></i>
            <span className="hidden sm:inline">Agendar Consulta Agora</span>
            <span className="sm:hidden">Agendar Agora</span>
          </button>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Sistema de Agendamento Principal */}
          <div id="agendamento" className="bg-white/95 backdrop-blur-sm rounded-xl md:rounded-3xl p-3 md:p-8 lg:p-12 border border-slate-200 shadow-2xl mb-8 md:mb-16">
            <div className="text-center mb-4 md:mb-8">
              <div className="inline-flex items-center justify-center w-12 md:w-20 h-12 md:h-20 bg-slate-100 rounded-lg md:rounded-2xl mb-3 md:mb-6 shadow-lg">
                <i className="ri-calendar-check-line text-xl md:text-3xl text-slate-700"></i>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-slate-800 mb-2 md:mb-4 px-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Agendamento Online
              </h3>
              <p className="text-slate-600 max-w-3xl mx-auto text-sm md:text-lg font-medium leading-relaxed px-3">
                Escolha o melhor horário para sua consulta através da nossa plataforma integrada
              </p>
            </div>
            
            {/* Widget Container Melhorado para Mobile */}
            <div className="bg-gradient-to-br from-slate-50/80 to-white/80 rounded-lg md:rounded-2xl p-2 md:p-6 lg:p-10 shadow-lg border border-slate-200/50 max-w-5xl mx-auto">
              {/* Widget do Doctoralia */}
              <div className="doctoralia-widget-wrapper min-h-[350px] md:min-h-[500px] bg-white rounded-md md:rounded-xl p-1 md:p-4 shadow-sm overflow-hidden">
                <a id="zl-url" className="zl-url" href="https://www.doctoralia.com.br/flavia-cristina-rodrigues-3/dentista/barueri" rel="nofollow" data-zlw-doctor="flavia-cristina-rodrigues-3" data-zlw-type="big_with_calendar" data-zlw-opinion="false" data-zlw-hide-branding="true" data-zlw-saas-only="true" data-zlw-a11y-title="Widget de marcação de consultas médicas">Flávia Cristina Rodrigues - Doctoralia.com.br</a>
              </div>
              
              {/* Fallback para mobile caso o widget não carregue bem */}
              <div className="block md:hidden mt-4 text-center">
                <a 
                  href="https://www.doctoralia.com.br/flavia-cristina-rodrigues-3/dentista/barueri"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-white px-6 py-3 rounded-lg transition-all duration-300 font-semibold shadow-lg text-sm whitespace-nowrap"
                >
                  <i className="ri-calendar-check-line text-lg"></i>
                  Agendar no Doctoralia
                </a>
              </div>
            </div>
          </div>

          {/* Mapa da Clínica */}
          <div className="mt-8 md:mt-16">
            <h4 className="text-xl md:text-3xl font-bold text-slate-800 mb-4 md:mb-8 text-center px-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              Como Chegar
            </h4>
            <div className="rounded-xl md:rounded-3xl overflow-hidden shadow-2xl max-w-5xl mx-auto border border-slate-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.4027234567!2d-46.87564!3d-23.50814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf03d3b7f8b5a5%3A0x1234567890abcdef!2sAv.%20Sagit%C3%A1rio%2C%20138%20-%20Alphaville%2C%20Barueri%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização da Clínica - Alpha Square Mall"
                className="md:h-[450px]"
              />
            </div>
            
            <div className="text-center mt-4 md:mt-8 px-4">
              <a 
                href="https://maps.app.goo.gl/H1QfipMUhZXk99eo7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 md:gap-3 bg-slate-800 hover:bg-slate-700 text-white px-4 md:px-8 py-3 md:py-4 rounded-lg md:rounded-xl transition-all duration-300 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap text-sm md:text-base w-full max-w-xs md:w-auto mx-auto justify-center"
              >
                <i className="ri-map-pin-line text-base md:text-xl"></i>
                <span className="hidden sm:inline">Ver no Google Maps</span>
                <span className="sm:hidden">Google Maps</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
